export default "__VITE_ASSET__DS5B4SRw__"